import React, { type ReactNode } from 'react'
import { ProgressBar } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'

const widthCss = css`
  width: 300px;
`

type Props = {
  percentComplete: number
  label?: ReactNode
}

export default function UploadProgressBar({ percentComplete, label }: Props): JSX.Element {
  const [t] = useTranslation()
  const adjustedPercent = Math.max(1, percentComplete)

  return (
    <div data-testid="upload-progress-bar" css={widthCss}>
      <ProgressBar
        value={adjustedPercent}
        message={label ?? t('group-management.importing-tree.heading', { percentage: adjustedPercent })}
      />
    </div>
  )
}
